import { Breadcrumb } from '@e3dc-react/shell/Elements/Header/Breadcrumbs'
import { TabsBarTab } from '@e3dc-react/shell/Elements/Tabs/TabsBar'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useHeaderBreadcrumbs, useHeaderTabs } from '@e3dc-react/shell/Libs/Header'
import { appUpdate } from '@e3dc-react/shell/State/App/AppActions'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { installationPaths } from '../constants'

/**
 * Sets page headers for the advanced settings section.
 */
const useSetAdvancedSettingsPageHeaders = ({ parentBreadcrumb, tabs }: { parentBreadcrumb: Breadcrumb; tabs: TabsBarTab[] }): void => {
  const { t } = useCustomTranslation()
  const { setBreadcrumbs } = useHeaderBreadcrumbs()
  const { setTabs, setActiveTab } = useHeaderTabs()
  const dispatch = useDispatch()
  const location = useLocation()

  const title = t('framework.advanced-settings')

  useEffect(() => {
    setBreadcrumbs([parentBreadcrumb, { title }])
    dispatch(appUpdate({ title }))

    setTabs(tabs)
    const parts = location.pathname.split('/')
    const currentPath = parts[parts.length - 1] as (typeof installationPaths)[keyof typeof installationPaths]
    const tabIndex = Object.values(installationPaths).indexOf(currentPath)
    setActiveTab(tabIndex === -1 ? 0 : tabIndex)

    return () => {
      setTabs([])
      setActiveTab(0)
      setBreadcrumbs([])
    }
  }, [location.pathname, title, setBreadcrumbs, setTabs, setActiveTab, dispatch, t, parentBreadcrumb, tabs])
}

export default useSetAdvancedSettingsPageHeaders
